import { createFileRoute } from "@tanstack/react-router";
import EditModeHeader from "lib/components/showroom2/edit/EditModeHeader";
import ShowroomIntro from "lib/components/showroom2/pages/ShowroomIntro";
import { ShowroomEditProvider } from "lib/components/showroom2/state/useShowroomState";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../components/withAuthentication";

function ShowroomIntroEdit() {
  const { builderId, planId, lotId } = useAppRouterParams();
  const showroomKey = [builderId, planId, lotId].filter(Boolean).join("-") || undefined;

  return (
    <ShowroomEditProvider key={showroomKey}>
      <ShowroomIntro header={<EditModeHeader />} />
    </ShowroomEditProvider>
  );
}

export const Route = createFileRoute("/showroom/edit/intro")({
  component: withAuthentication(ShowroomIntroEdit, {
    permissions: ["EDIT_SHOWROOM_INTRO"],
    products: ["showroom"],
  }),
});
